import { create } from "zustand";

export const useSheet = create((set) => ({
  content: null,
  type: null,
  loadingState: "empty",
  setContent: (entry) => set({ content: entry, loadingState: "loading" }),
  setLoadingState: (value) => set({ loadingState: value }),
}));
